import React from 'react';
import { tv } from 'tailwind-variants';

export type TypographyVariant =
  | 'display1'
  | 'display2'
  | 'display3'
  | 'title1'
  | 'title2'
  | 'title3'
  | 'title4'
  | 'title5'
  | 'subtitle1'
  | 'subtitle2'
  | 'body1'
  | 'body2'
  | 'caption'
  | 'captionBold'
  | 'button'
  | 'link';

type TypographyTag =
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'h5'
  | 'h6'
  | 'p'
  | 'span'
  | 'div'
  | 'label'
  | 'li'
  | 'b';

interface Props {
  variant?: TypographyVariant;
  as?: TypographyTag;
  className?: string;
  children?: React.ReactNode;
  id?: string;
}

// Figma: EVNoIvOdB90RZfOGSBl3qM — node 24034:6184
const typography = tv({
  base: 'font-sans',
  variants: {
    variant: {
      display1: 'text-4xl leading-8 font-extrabold', // 36px / 32 / 800
      display2: 'text-2xl leading-8 font-extrabold', // 24px / 32 / 800
      display3: 'text-lg leading-6 font-extrabold', // 18px / 24 / 800
      title1: 'text-2xl leading-8 font-bold', // 24px / 32 / 700
      title2: 'text-xl leading-7 font-bold', // 20px / 28 / 700
      title3: 'text-xl leading-7 font-normal', // 20px / 28 / 400
      title4: 'text-lg leading-6 font-bold', // 18px / 24 / 700
      title5: 'text-lg leading-6 font-normal', // 18px / 24 / 400
      subtitle1: 'text-base leading-6 font-bold', // 16px / 24 / 700
      subtitle2: 'text-sm leading-5 font-bold', // 14px / 20 / 700
      body1: 'text-base leading-6 font-normal', // 16px / 24 / 400
      body2: 'text-sm leading-5 font-normal', // 14px / 20 / 400
      caption: 'text-xs leading-4 font-normal', // 12px / 16 / 400
      captionBold: 'text-xs leading-4 font-bold', // 12px / 16 / 700
      button: 'text-base leading-5 font-bold', // 16px / 20 / 700
      link: 'text-sm leading-4 font-bold', // 14px / 16 / 700
    },
  },
  defaultVariants: {
    variant: 'body2',
  },
});

const Typography = ({ variant = 'body2', as: Tag = 'span', className, children, id }: Props) => (
  <Tag id={id} className={typography({ variant, className })}>
    {children}
  </Tag>
);

export default Typography;
